import { Fund } from "creso-core/types";
import { format } from "date-fns";

export function getFundsDateOverlapRange(
  funds: Fund[],
  timePeriod: "1 yr" | "3 yr" | "5 yr" | "10 yr"
) {
  const latestInceptionDate = funds.reduce((max, fund) => {
    return Math.max(max, new Date(fund.inception_date).getTime());
  }, 0);

  let startDate = new Date(latestInceptionDate);
  switch (timePeriod) {
    case "1 yr": {
      const requestedStartDate = new Date(
        new Date().setDate(new Date().getDate() - 365 * 1)
      );
      startDate = new Date(
        Math.max(startDate.getTime(), requestedStartDate.getTime())
      );
      break;
    }
    case "3 yr": {
      const requestedStartDate = new Date(
        new Date().setDate(new Date().getDate() - 365 * 3)
      );
      startDate = new Date(
        Math.max(startDate.getTime(), requestedStartDate.getTime())
      );
      break;
    }
    case "5 yr": {
      const requestedStartDate = new Date(
        new Date().setDate(new Date().getDate() - 365 * 5)
      );
      startDate = new Date(
        Math.max(startDate.getTime(), requestedStartDate.getTime())
      );
      break;
    }
    case "10 yr": {
      const requestedStartDate = new Date(
        new Date().setDate(new Date().getDate() - 365 * 10)
      );
      startDate = new Date(
        Math.max(startDate.getTime(), requestedStartDate.getTime())
      );
      break;
    }
    default:
      break;
  }

  const endDate = format(new Date(), "yyyy-MM-dd");

  return { startDate: format(startDate, "yyyy-MM-dd"), endDate };
}
